import React from 'react';

import cs from 'classnames';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

type Props = {
  onClick?: () => unknown;
  children?: React.ReactNode;
  className?: string;
  tooltip?: React.ReactNode;
};

export function ClickToEditButton({
  onClick,
  tooltip,
  children,
  className,
}: Props) {
  return (
    <LazyTooltip tooltip={tooltip != null ? tooltip : gt('Click to Edit')}>
      <button
        data-testid="click-to-edit-button"
        className="btn btn-link text-muted ml-1 p-0"
        onClick={onClick}
      >
        <i
          className={cs(
            'fa fa-fw fa-pen',
            {
              'mr-1': children != null,
            },
            className
          )}
        />
        {children}
      </button>
    </LazyTooltip>
  );
}
